export default __webpack_public_path__ + "static/media/united-states-of-america.c29455bd.svg";